import { render, staticRenderFns } from "./PartDetailsTable.vue?vue&type=template&id=d0155000"
import script from "./PartDetailsTable.ts?vue&type=script&lang=ts&external"
export * from "./PartDetailsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./PartDetailsTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports